import { useEffect, useMemo, useState } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import { toModalImage } from 'Pods/ThreeDStudio/Shared/ImageModal/Utils/toModalImage'

// Loads one community image by slug, for a URL naming an image the gallery has not loaded:
// a shared link, or an image past the pages fetched so far. Pass null to skip.
function useGalleryImageBySlug(slug) {
  const { getData } = useApiGet()
  const [loaded, setLoaded] = useState(null)

  useEffect(() => {
    if (!slug) return

    getData({
      path: `/api/internal/generator/images/${slug}`,
      onSuccess: (response) => {
        setLoaded({ slug, attributes: response?.data?.data?.attributes ?? null })
      },
    })
  }, [getData, slug])

  // Keyed on the slug so a stale image never shows while the next one loads.
  const attributes = slug && loaded?.slug === slug ? loaded.attributes : null

  return useMemo(() => toModalImage(attributes), [attributes])
}

export default useGalleryImageBySlug
